<template>
  <div class="d-flex align-items-center justify-content-center">
    <div class="step-title">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.step-title {
  font-size: 1.5rem;
  width: 70ch;
  align-content: center;
  text-align: center;
  font-weight: bold;
}


// Extra small (xs)
@media (max-width: 575px) {
  // Your styles for extra small screens here
  .step-title {
    font-size: 1.2rem;
  }
}

// Small (sm)
@media (min-width: 576px) and (max-width: 767px) {
  // Your styles for small screens here
}

// Medium (md)
@media (min-width: 768px) and (max-width: 991px) {
  // Your styles for medium screens here
}

// Large (lg)
@media (min-width: 992px) and (max-width: 1199px) {
  // Your styles for large screens here
}

// Extra large (xl)
@media (min-width: 1200px) {
  // Your styles for extra large screens here
}
</style>